import axios from 'axios';

import authHeader from '../auth-header';
import tokenHeader from '../token-header';

import baseUrl from '../base-url';
const API_URL = baseUrl()+"/api/all/";

const EmailBroadcastUrl = 'broadcast-email';
const DetailEmailBroadcastUrl = 'broadcast-email/';
const DeleteBroadcastEmail = 'broadcast-email/';

class EmailBroadcastService {

    getEmailBroadcast(currentPage, pageSize, filter) {
        return axios.get(
            API_URL + EmailBroadcastUrl + '?pageNo=' + currentPage + '&pageSize=' + pageSize + '&filter=' + filter,
            {
                headers: authHeader()
            }
        )
    }

    getDetailEmailBroadcast(id_broadcast) {
        return axios.get(
            API_URL + DetailEmailBroadcastUrl + id_broadcast, {
                headers: authHeader()
            }
        )
    }

    postEmailBroadcast(request) {
        let form = new FormData();
        form.append('subject', request.subject);
        form.append('text', request.text);
        form.append('tujuan', '1');
        form.append('idKategoriAnggota', '1');
        
        if(request.tujuanEmail && request.tujuanEmail.length > 0) {
            for (let i = 0; i < request.tujuanEmail.length; i++) {
                let user = request.tujuanEmail[i];                                
                form.append(`tujuanEmail[${i}].id_user`, user.id_user)
                form.append(`tujuanEmail[${i}].email`, user.email);
            }
        }

        if(request.cc && request.cc.length > 0) {
            for (let i = 0; i < request.cc.length; i++) {
                let user = request.cc[i];                                      
                form.append(`cc[${i}].id_user`, user.id_user)
                form.append(`cc[${i}].email`, user.email);
            }
        }

        if(request.bcc && request.bcc.length > 0) {
            for (let i = 0; i < request.bcc.length; i++) {
                let user = request.bcc[i];                                   
                form.append(`bcc[${i}].id_user`, user.id_user)
                form.append(`bcc[${i}].email`, user.email);
            }
        } 

        if(request.file && request.file.length > 0) {
            for (let i = 0; i < request.file.length; i++) {
                let singleFile = request.file[i];                                   
                form.append(`file[${i}]`, singleFile);
            }
        }

        return axios.post(API_URL + EmailBroadcastUrl, form, {
            headers: {
                'Content-Type': 'multipart/form-data', 
                'Authorization': tokenHeader()
            }
        })
    }

    deleteBroadcastEmail(formData) {

        return axios
            .delete(
                API_URL + DeleteBroadcastEmail + formData.id_broadcast,
                { headers: authHeader() }
            );
    }

}

export default new EmailBroadcastService();